<template>
  <div class="card-wrapper">
    <div class="question-header">
      <div class="left-wrapper">
        <div class="question-number-wrapper">
          <span class="question-number">{{partData.order}}.</span>
        </div>

        <span class="question-type-text">{{$t('step')}}: </span>

        <div :id="`wt-step-0-part-${index}`" class="question-dropdown" v-click-outside="dropdownOutsideClick">
         <div class="tooltips">
          <div class="dropdown-button" :class="{'active': partDropdownVisible}" @click="partDropdownVisible = !partDropdownVisible">
            <img :src="partTypes.find(type => type.id === selectedTypeID).icon" />
            <span>{{partTypes.find(type => type.id === selectedTypeID).name}}</span>
            <img src="@/assets/images/arrowdown.svg" class="arrow" />
          </div>
          <div class="tooltiptext">{{ $t("change_the_type") }}</div>
        </div>

          <div class="dropdown-items" v-if="partDropdownVisible">
            <div v-for="item in partTypes" class="dropdown-item" @click="() => selectType(item.id)" v-if="item?.showOnDropdown !== false">
              <img :src="item.icon" />
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-wrapper">
        <!-- <Switch v-model="partData.status" /> -->
        <div class="tooltips">
        <img v-if="![5, 6, 7, 8].includes(selectedTypeID)" style="height: 16px" src="@/assets/images/questionMark.svg" @click="onTour(this.selectedTypeID)" />
        </div>

        <div class="tooltips">
        <img src="@/assets/images/arrow-up.svg" @click="onChangePosition('up', partData.order)"/>
          <div class="tooltiptext">{{ $t("move_up") }}</div>
        </div>
        <div class="tooltips">
        <img src="@/assets/images/arrow-down.svg" @click="onChangePosition('down', partData.order)" />
          <div class="tooltiptext">{{ $t("move_down") }}</div>
        </div>
        <div class="tooltips">
        <img src="@/assets/images/copyOutline.svg" @click="onDuplicateQuestion(partData.order)" />
        <div class="tooltiptext">{{ $t("copy") }}</div>
      </div>
        <div class="tooltips">
        <img src="@/assets/images/settingsOutline.svg" @click="partSettingsModal = true" />
          <div class="tooltiptext">{{ $t("settings") }}</div>
        </div>
        <div class="tooltips">
        <img src="@/assets/images/trashOutline.svg" @click="handleQuestionDelete" />
        <div class="tooltiptext">{{ $t("delete") }}</div>
      </div>
      </div>
    </div>

    <Transition name="slide-up">
      <div v-if="expanded" class="question-body">
        <div v-if="selectedTypeID === 1" class="port-body">
          <span class="title-input">{{$t('what_people_will_learn')}}</span>
          <div :id="`wt-step-1-part-${index}`" class="question-wrapper">

            <textarea
                style="width: 100%"
                :placeholder="this.$t('enter_your_welcome_text')"
                rows="5"
                v-model="partData.name"
                v-ai-generator="aiSocket"
            />

            <div :id="`wt-step-2-part-${index}`" class="input-actions">
              <div class="tooltips">
                <img src="@/assets/images/addImage.svg" @click="addVisualVisible = true"/>
                <div class="tooltiptext">{{$t("add_visual")}}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedTypeID === 2" class="port-body">
          <span class="title-input">{{$t('explanation_text')}}</span>
          <textarea :id="`au-step-1-part-${index}`" class="form-input" style="width: 100%" :placeholder="this.$t('please_explanation_here')" v-model="partData.name" v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>
          <br/><br/>
          <span class="title-input">{{$t('audio_cover_photo')}}</span>

          <div class="upload-row">
            <div :id="`au-step-2-part-${index}`" >
              <FileDrop class="w-100"  type="mp3" :on-file-selected="handleAudioFile" :selected-file="partData.content?.attach[0]?.file?.attachUrl" :file-info="partData.content?.attach[0]?.file?.info" :attach="partData.content?.attach[0]?.attach" :not-binary="true" :on-delete="() => handleImageDelete(partData.content?.attach[0])" />
            </div>
            <div :id="`au-step-3-part-${index}`">
              <FileDrop :ratio="'1920*1920'" :on-file-selected="handleAudioCoverFile"  :selected-file="partData.content?.attach[1]?.file?.attachUrl" :file-info="partData.content?.attach[1]?.file?.info" :attach="partData.content?.attach[1]?.attach" :not-binary="true" :on-delete="() => handleImageDelete(partData.content?.attach[1])" />
            </div>
          </div>
        </div>

        <div v-if="selectedTypeID === 3" class="port-body">
          <div class="video-content-header">
            <span class="title-input">{{$t('explanation_text')}}</span>
            <button
              class="ai-video-button-new"
              @click="openVideoGenerationModal"
              :title="$t('generate_ai_video')"
            >
              <img src="@/assets/images/magicWand.svg" alt="Generate AI Video" />
              <span>{{$t('generate_video')}}</span>
            </button>
          </div>
          <textarea :id="`vi-step-1-part-${index}`" class="form-input" style="width: 100%" :placeholder="this.$t('please_explanation_here')" v-model="partData.name"  v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>

          <br/><br/>
          <span class="title-input">{{$t('video_cover_photo')}}</span>

          <div class="upload-row">
            <div class="w-100" :id="`vi-step-2-part-${index}`">
              <FileDrop type="mp4" :on-file-selected="handleVideoFile" :selected-file="partData.content?.attach[0]?.file?.attachUrl" :file-info="partData.content?.attach[0]?.file?.info" :attach="partData.content?.attach[0]?.attach" :not-binary="true"  :on-delete="() => handleImageDelete(partData.content?.attach[0])" />
            </div>
            <div :id="`vi-step-3-part-${index}`">
              <FileDrop :ratio="'1920*1080'" :on-file-selected="handleVideoCoverFile"  :selected-file="partData.content?.attach[1]?.file?.attachUrl" :file-info="partData.content?.attach[1]?.file?.info" :attach="partData.content?.attach[1]?.attach" :not-binary="true" :on-delete="() => handleImageDelete(partData.content?.attach[1])" />
            </div>
          </div>

          <div :id="`vi-step-4-part-${index}`">
          <ExpandableSetting :title="$t('expand_srt_options')">
            <div class="srt-file-row">
              <div class="srt-info">
                <span class="title">
                  {{$t('srt_file')}}
                </span>
                <span class="description">
                  {{$t('srt_file_description')}}
                </span>
              </div>

              <div class="file-drop">
                <FileDrop
                    type="srt"
                    :on-file-selected="handleSrtFile"
                    :selected-file="partData.content?.srt?.file?.attachUrl"
                    :attach="partData.content?.srt?.attach"
                    :on-delete="() => handleSrtDelete(partData.content.srt)"
                    :not-binary="true"
                    :file-info="partData.content?.srt?.file?.info"
                />
              </div>
            </div>
          </ExpandableSetting>
          </div>
        </div>

        <div v-if="selectedTypeID === 4" class="port-body">
          <textarea class="question-input" :placeholder="$t('add_your_question_here')" v-model="partData.name" v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>

          <div class="answers-body">
            <h4>Answers</h4>
            <div class="answer-input-row" v-for="answer in partData.content.options">
              <img src="@/assets/images/drag.svg" />
              <input class="answer-input" :placeholder="$t('add_your_answer_here')" v-model="answer.name" />
              <img src="@/assets/images/trashOutline.svg" @click="() => handleDelete(answer.id)" />
            </div>

            <button class="add-answer-button no-text-select" @click="addAnswer">
              <img src="@/assets/images/plusBlue.svg" />
              <span>{{$t('add_an_answer')}}</span>
            </button>
          </div>
        </div>

        <div v-if="selectedTypeID === 5" class="port-body">
          <span class="title-input">{{ $t('summary_type') }}</span>
          <div class="question-wrapper mb-2">

            <textarea class="question-input" :placeholder="this.$t('add_your_summary_title')" v-model="partData.name"  v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>

            <div class="input-actions">
              <div class="tooltips">
              <img src="@/assets/images/addImage.svg" @click="addVisualVisible = true"/>
                <div class="tooltiptext">{{$t("add_visual")}}</div>
              </div>
            </div>
          </div>

          <quill-editor theme="snow" v-model:content="partData.description" content-type="html" @ready="onSummaryQuillReady"></quill-editor>
        </div>

        <div v-if="selectedTypeID === 6" class="port-body">
          <span class="title-input">{{$t('success_type')}}</span>
          <textarea style="width: 100%" :placeholder="this.$t('add_success_paragraph')" rows="5" v-model="partData.name"  v-ai-generator="aiSocket"/>
        </div>

        <div v-if="selectedTypeID === 8" class="port-body">
          <span class="title-input">{{$t('failed_type')}}</span>
          <textarea style="width: 100%" :placeholder="this.$t('add_failed_paragraph')" rows="5" v-model="partData.name"  v-ai-generator="aiSocket"/>
        </div>

        <div v-if="selectedTypeID === 7" class="port-body">
          <span class="title-input">{{$t('self_chat_type')}}</span>
          <span class="description-text">{{$t('self_conversation')}}</span>
        </div>

        <div v-if="selectedTypeID === 9" class="port-body">
          <textarea class="question-input" :placeholder="$t('add_your_question_here')" v-model="partData.name" v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>
          <textarea class="question-input" :placeholder="$t('explanation_text')" v-model="partData.description" v-textarea-autoresize  v-ai-generator="aiSocket"></textarea>

          <div class="agent-select-wrapper">
            <span class="title-input">{{ $t('select_agent') }}</span>
            <SelectBox
                :options="agentOptions"
                :model-value="partData.content.settings.agentId"
                :placeholder="$t('select_agent')"
                :loading="agentsLoading"
                :full-width="true"
                :search-enabled="true"
                @update:modelValue="onAgentSelect"
            />
          </div>
        </div>
      </div>
    </Transition>

    <div class="toggle-card" :class="{'closed': !expanded}" @click="toggleCard">
      <img src="@/assets/images/cross.svg" />
    </div>

    <v-tour :name="'welcomeTextTour-' + index" :steps="welcomeTextSteps" :options="labels"></v-tour>
    <v-tour :name="'audioTour-' + index" :steps="audioSteps" :options="labels"></v-tour>
    <v-tour :name="'videoTour-' + index" :steps="videoSteps" :options="labels"></v-tour>
    <v-tour :name="'scenarioTour-' + index" :steps="scenarioSteps" :options="labels"></v-tour>


    <AddVisualModal :not-binary=true :visible="addVisualVisible" :on-hide="hideAddVisual" v-model="partData.content.attach" />
    <VideoGenerationModal
      :visible="videoGenerationModalVisible"
      :on-hide="hideVideoGenerationModal"
      :initial-text="partData.name"
      :on-video-generated="handleVideoGenerated"
      :ai-socket="aiSocket"
    />
    <PartSettingsModal :visible="partSettingsModal" :on-hide="hidePartSettingsModal" :test-list="testList" :settings="partData.content.settings" :selected-type="selectedTypeID" />
  </div>
</template>

<script>
import textOutline from "@/assets/images/textOutline.svg";
import audioOutline from "@/assets/images/audioOutline.png";
import videoOutline from "@/assets/images/videoOutline.png";
import questionOutline from "@/assets/images/questionOutline.png";
import receipt2Outline from "@/assets/images/receipt2Outline.png";
import shieldOutline from "@/assets/images/shieldOutline.png";
import messageOutline from "@/assets/images/messageOutline.svg";
import failedShieldOutline from "@/assets/images/failedShieldOutline.svg";
import agentsIcon from "@/assets/images/agentsOutline.svg";

import GradeInput from "@/components/GradeInput.vue";
import StarInput from "@/components/StarInput.vue";
import PartSettingsModal from "@/components/modals/PartSettingsModal.vue";
import FileDrop from "@/components/FileDrop.vue";
import AddVisualModal from "@/components/modals/AddVisualModal.vue";
import ExpandableSetting from "@/components/ExpandableSetting.vue";
import SelectBox from "@/components/SelectBox.vue";
import draggable from "vuedraggable";
import AddSingleVisualModal from "@/components/modals/AddSingleVisualModal.vue";
import VideoGenerationModal from "@/components/modals/VideoGenerationModal.vue";
import agentService from "@/service/agentService";


export default {
  components: {AddSingleVisualModal, VideoGenerationModal,
    draggable, SelectBox, ExpandableSetting, AddVisualModal, FileDrop, PartSettingsModal, StarInput, GradeInput},
  props: {
    index:{
      type:Number,
      default:null
    },
    data: {
      type: Object,
      default: {}
    },
    partUpdate: {
      type: Function,
      default: () => {}
    },
    onDelete: {
      type: Function,
      default: () => {}
    },
    onChangePosition: {
      type: Function,
      default: () => {}
    },
    onDuplicateQuestion: {
      type: Function,
      default: () => {}
    },
    testList: {
      type: Array,
      default: []
    },
    deleteList: {
      type: Array,
      default: []
    },
    aiSocket: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      labels:this.tourConfig,
      scenarioSteps: [
        {
          target: `#wt-step-0-part-${this.index}`,
          content: this.$t("welcomeText.step0"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#sc-step-1-part-${this.index}`,
          content: this.$t("scenarioSteps.step1"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#sc-step-2-part-${this.index}`,
          content: this.$t("scenarioSteps.step2"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        }
      ],
      videoSteps: [
        {
          target: `#wt-step-0-part-${this.index}`,
          content: this.$t("welcomeText.step0"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#vi-step-1-part-${this.index}`,
          content: this.$t("videoSteps.step1"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#vi-step-2-part-${this.index}`,
          content: this.$t("videoSteps.step2"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#vi-step-3-part-${this.index}`,
          content: this.$t("videoSteps.step3"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#vi-step-4-part-${this.index}`,
          content: this.$t("videoSteps.step4"),
          params: {
            placement: 'right',
            enableScrolling: false,
          }
        }
      ],

      audioSteps: [
        {
          target: `#wt-step-0-part-${this.index}`,
          content: this.$t("welcomeText.step0"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#au-step-1-part-${this.index}`,
          content: this.$t("audioSteps.step1"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#au-step-2-part-${this.index}`,
          content: this.$t("audioSteps.step2"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#au-step-3-part-${this.index}`,
          content: this.$t("audioSteps.step3"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        }
      ],

      welcomeTextSteps: [
        {
          target: `#wt-step-0-part-${this.index}`,
          content: this.$t("welcomeText.step0"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#wt-step-1-part-${this.index}`,
          content: this.$t("welcomeText.step1"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        },
        {
          target: `#wt-step-2-part-${this.index}`,
          content: this.$t("welcomeText.step2"),
          params: {
            placement: 'top',
            enableScrolling: false,
            highlight:true
          }
        }
      ],
      expanded: true,
      selectedTypeID: 1,
      partDropdownVisible: false,
      partSettingsModal: false,
      partOrder: 1,
      partTypes: [
        {
          id: 1,
          name: this.$t('welcome_text'),
          icon: textOutline,
          showOnDropdown: false,
          data:  {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "welcomeText",
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },
        {
          id: 2,
          name: this.$t('audio_type'),
          icon: audioOutline,
          data: {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "audio",
              attach: [
                {
                  name: "Audio",
                  attach: null,
                  type: "audio",
                  file:{
                    attachUrl:null
                  }
                },
                {
                  name: "Cover Photo",
                  attach: null,
                  type: "cover",
                  file:{
                    attachUrl: null
                  }
                }
              ],
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },
        {
          id: 3,
          name: this.$t('video_type'),
          icon: videoOutline,
          data: {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "video",
              attach: [
                {
                  name: "Video",
                  attach: null,
                  type: "video",
                  file:{
                    attachUrl:null,
                  }
                },
                {
                  name: "Cover Photo",
                  attach: null,
                  type: "cover",
                  file:{
                    attachUrl: null
                  }
                }
              ],
              srt: {
                name: "Srt File",
                type: "srt",
                attach: null
              },
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },
        {
          id: 4,
          name: this.$t('question_type_program'),
          icon: questionOutline,
          data: {
            name: "",
            status: 1,
            order: 1,
            content: {
              attach:[{
                file:{
                  attachUrl:null
                }
              }

              ],
              type: "multiple",
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
              options: [
                {
                  id: 0,
                  name: "Option A"
                },
                {
                  id: 1,
                  name: "Option B",
                },
              ]
            },
          }
        },
        {
          id: 5,
          name: this.$t('summary_type'),
          icon: receipt2Outline,
          data:  {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "summary",
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },

       /* {
          id: 7,
          name: this.$t('self_chat_type'),
          icon: messageOutline,
          data:  {
            name: "Self Chat",
            status: 1,
            order: 1,
            content: {
              type: "selfChat",
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },

        {
          id: 9,
          name: this.$t('scenario_text'),
          icon: messageOutline,
          data:  {
            name: "Scenario Text",
            status: 1,
            order: 1,
            content: {
              type: "scenarioText",
              settings: {
                drawer: false,
                required: true,
                other: false,
                chat: false,
                where: []
              },
              options: [
                {
                  id: 0,
                  name: "Aşırı talepkarlık"
                },
                {
                  id: 1,
                  name: "Değerini azaltma",
                },
              ]
            }
          }
        },*/

        {
          id: 9,
          name: this.$t('agent_type'),
          icon: agentsIcon,
          data:  {
            name: "",
            description: "",
            status: 1,
            order: 1,
            content: {
              type: "agentRedirect",
              settings: {
                agentId: null,
              },
            }
          }
        },

        {
          id: 6,
          name: this.$t('success_type'),
          icon: shieldOutline,
          data:  {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "success",
              settings: {
                drawer: {
                  header: 'Successfully Completed',
                  body: 'Move to the next step',
                  actions: [
                    {
                      actionType: "primary",
                      actionText: "Continue",
                      action: "next",
                    }
                  ]
                },
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },
        {
          id: 8,
          name: this.$t('failed_type'),
          icon: failedShieldOutline,
          data:  {
            name: "",
            status: 1,
            order: 1,
            content: {
              type: "failed",
              settings: {
                drawer: {
                  header: 'Step Failed',
                  body: 'Please repeat the step',
                  actions: [
                    {
                      actionType: "primary",
                      actionText: "Repeat",
                      action: "repeat",
                    }
                  ]
                },
                required: true,
                other: false,
                chat: false,
                where: []
              },
            }
          }
        },


      ],

      partData: {},

      answers: [{
        id: 0,
        value: ""
      }],
      addVisualVisible: false,
      videoGenerationModalVisible: false,
      agents: [],
      agentsLoading: false,
    }
  },
  computed: {
    currentLocale() {
      return localStorage.getItem('userLanguage') ||
          localStorage.getItem('language') ||
          localStorage.getItem('locale') ||
          this.$i18n?.locale ||
          'tr';
    },
    agentOptions() {
      return (this.agents || []).map(agent => ({
        value: agent.token,
        text: this.getAgentName(agent.name),
      }));
    },
  },
  created() {
    if (this.data) {
      if (this.data.content.type === "welcome-text" || this.data.content.type === "welcomeText") {
        this.selectedTypeID = 1;
      } else if (this.data.content.type === "audio") {
        this.selectedTypeID = 2;
      } else if (this.data.content.type === "video") {
        this.selectedTypeID = 3;
      } else if (this.data.content.type === "multiple") {
        this.selectedTypeID = 4;
      } else if (this.data.content.type === "summary") {
        this.selectedTypeID = 5;
      } else if (this.data.content.type === "success") {
        this.selectedTypeID = 6;
      } else if (this.data.content.type === "selfChat") {
        this.selectedTypeID = 7;
      } else if (this.data.content.type === "failed") {
        this.selectedTypeID = 8;
      } else if (this.data.content.type === "scenarioText") {
        this.selectedTypeID = 9;
      } else if (this.data.content.type === "agentRedirect") {
        this.selectedTypeID = 9;
      }

      if (!this.data?.content?.attach) {
        this.data.content.attach  = [];
      }

      this.partData = this.data;
      this.partOrder = this.data.order;
      this._originalDescription = this.data.description;
    } else {
      this.partData = this.partTypes.find(type => type.id === this.selectedTypeID).data;
    }

    if (this.selectedTypeID === 9) {
      this.loadAgents();
    }
  },
  watch: {
    partData: {
      handler: function (newVal, oldVal) {
        this.partUpdate(newVal);
      },
      deep: true
    },
  },
  methods: {
    onSummaryQuillReady(quill) {
      const html = this._originalDescription;
      if (!html) return;

      this.$nextTick(() => {
        // Quill 2 expects convert({ html }), Quill 1 expects convert(html).
        // Calling the wrong one returns an empty delta instead of throwing.
        let delta = quill.clipboard.convert({ html });
        if (!delta || delta.length() === 0) {
          delta = quill.clipboard.convert(html);
        }
        // Never overwrite what vue-quill already rendered via setHTML().
        if (delta && delta.length() > 0) {
          quill.setContents(delta, 'silent');
        }
      });
    },
    onTour(type){
      if(type===1){
      this.$tours[`welcomeTextTour-${this.index}`].start()
      }else if(type===2){
        this.$tours[`audioTour-${this.index}`].start()
      }else if(type===3){
        this.$tours[`videoTour-${this.index}`].start()
      }else if(type===9){
        this.$tours[`scenarioTour-${this.index}`].start()
      }
    },
    dropdownOutsideClick() {
      this.partDropdownVisible = false;
    },
    selectType(typeID) {
      this.selectedTypeID = typeID;
      this.partDropdownVisible = false;

      this.partData = this.partTypes.find(type => type.id === typeID).data;
      this.partData.order = this.partOrder;

      if (typeID === 9 && this.agents.length === 0) {
        this.loadAgents();
      }
    },
    getAgentName(name) {
      if (!name) return '-';
      if (typeof name === 'string') return name;
      return name[this.currentLocale] || name['tr'] || name['en'] || Object.values(name)[0] || '-';
    },
    async loadAgents() {
      const companyId = JSON.parse(localStorage.getItem('user'))?.companyId;
      if (!companyId) return;

      this.agentsLoading = true;
      try {
        const response = await agentService.getAgents(companyId, 1, 100);
        if (response?.data?.success) {
          this.agents = response.data.agents || [];
        }
      } catch (error) {
        this.agents = [];
      }
      this.agentsLoading = false;
    },
    onAgentSelect(agentId) {
      if (!this.partData.content.settings) {
        this.partData.content.settings = {};
      }
      this.partData.content.settings.agentId = agentId;
    },
    toggleCard() {
      this.expanded = !this.expanded;
    },
    handleQuestionDelete() {
      this.onDelete(this.partData.order);
    },
    hidePartSettingsModal() {
      this.partSettingsModal = false;
    },
    handleAudioFile(file) {
      if (this.partData.content.type !== "audio") {
        return;
      }

      this.partData.content.attach[0].attach = file;
    },
    handleAudioCoverFile(file) {
      if (this.partData.content.type !== "audio") {
        return;
      }
      this.partData.content.attach[1].attach = file;
    },
    handleVideoFile(file) {
      if (this.partData.content.type !== "video") {
        return;
      }

      this.partData.content.attach[0].attach = file;
    },
    handleVideoCoverFile(file) {
      if (this.partData.content.type !== "video") {
        return;
      }
      this.partData.content.attach[1].attach = file;
    },
    handleSrtFile(file) {
      if (this.partData.content.type !== "video") {
        return;
      }

      // modules[0][subModules][0][parts][0][content][srt][name]:Srt File
      // modules[0][subModules][0][parts][0][content][srt][type]: srt
      // modules[0][subModules][0][parts][0][content][srt][attach]: srtfile Url

      this.partData.content.srt = {
        name: "Srt File",
        type: "srt",
        attach: file
      };
    },
    handleImageDelete(element) {
      this.deleteList.push(element.file.fillableId);
        element.attach = null;
        element.attachUrl = null;
    },

    handleSrtDelete(element) {
      this.deleteList.push(element.file.fillableId);
        element.attach = null;
        element.attachUrl = null;
    },
    addAnswer() {
      this.partData.content.options.push({
        id: this.partData.content.options.length + 1,
        name: ""
      });
    },
    handleDelete(id) {
      if (this.partData.content.options.length === 1) {
        this.partData.content.options[0] = "";
      } else {
        this.partData.content.options = this.partData.content.options.filter(answer => answer.id !== id);
      }
    },
    hideAddVisual() {
      this.addVisualVisible = false;
    },
    openVideoGenerationModal() {
      this.videoGenerationModalVisible = true;
    },
    hideVideoGenerationModal() {
      this.videoGenerationModalVisible = false;
    },
    handleVideoGenerated(videoData) {
      // Update the video attachment with generated video data
      this.partData.content.attach[0] = {
        name: "Video",
        attach: videoData.attach,
        type: "video",
        file: {
          attachUrl: videoData.file.attachUrl,
          fillableId: videoData.file.fillableId
        }
      };

      this.$snackbar.add({
        text: this.$t('video_generated_successfully'),
        type: 'success',
      });
    },
  }
}
</script>

<style scoped>
.card-wrapper {
  position: relative;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 16px;
  padding: 20px 20px 20px 28px;
  display: flex;
  flex-direction: column;
}

.question-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.left-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.right-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px
}
.tooltips {
  position: relative;
  display: inline-block;
}

.tooltips .tooltiptext {
  visibility: hidden;
  min-width: 100px;
  background-color: #0b1242;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -50px;
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 12px;

}

.tooltips .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltips:hover .tooltiptext {
  visibility: visible;
  transition: visibility 0s 1.5s;
}

.question-number-wrapper {
  background-color: #040C2D;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-number {
  font-family: 'euclid_medium', sans-serif;
  font-size: 12px;
  color: #FFFFFF;
}

.question-body {
  padding: 15px 0;
}

.question-dropdown {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 5px;
}

.question-dropdown img {
  height: 16px;
  width: 16px;
}

.question-dropdown span {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 12px;
}

.dropdown-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
}

.dropdown-button:hover, .dropdown-button.active {
  background-color: #F2F4F7;
}

.dropdown-button .arrow {
  transition: transform 0.1s linear;
}

.dropdown-button.active .arrow {
  transform: rotate(180deg);
}

.dropdown-items {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  background-color: #FFFFFF;
  border: 1px solid #EAECF0;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 99;
}

.dropdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
}

.dropdown-item:hover {
  background-color: #F5F7FA;
}

.question-input, .answer-input  {
  border: none;
  outline: none;
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  background-color: #F5F5F5;
  color: #282A36;
  padding: 15px;
  border-radius: 8px;
}

.question-input {
  width: 100%;
}

.answer-input {
  width: 300px;
}

.answer-input-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

h4 {
  font-family: euclid_medium, sans-serif;
  font-size: 16px;
  color: #101828;
  margin: 0;
  padding: 0;
}

.answers-body {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.add-answer-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 5px;
  border-radius: 8px;
  color: #4A68F8;
  margin-top: 10px;
  border: none;
  outline: none;
  background-color: transparent;
}

.add-answer-button:hover {
  background-color: #f3f4ff;
}

.toggle-card {
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  height: 20px;
  width: 20px;
  background-color: #FFFFFF;
  border: 1px solid #D0D5DD;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.toggle-card img {
  height: 9px;
  width: 9px;
}

.toggle-card.closed img {
  transform: rotate(-45deg);
}

.number-input-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
  height: 48px;
  width: 350px;
}

.number-input-row input {
  outline: none;
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  background-color: #ffffff;
  color: #282A36;
  padding: 15px;
  width: 100%;
  border-top: 1px solid #D0D5DD;
  border-bottom: 1px solid #D0D5DD;
  border-left: none;
  border-right: none;
  height: 48px;
}

.number-input-row .left-part, .number-input-row .right-part {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 40px;
  background-color: #FCFCFD;
  border: 1px solid #D0D5DD;
}

.number-input-row .left-part img, .number-input-row .right-part img {
  height: 16px;
  width: 16px;
}

.number-input-row .left-part {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.number-input-row .right-part {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.title-input {
  border: none;
  outline: none;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  background-color: transparent;
  color: #040C2D;
  display: block;
  margin-bottom: 10px;
}

.description-text {
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #667085;
  margin-bottom: 10px;
}

.upload-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}

.upload-row > div {
  flex: 1;
}

.question-wrapper {
  position: relative;
  display: flex;
}

.question-wrapper .input-actions {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.srt-file-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}

.srt-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.srt-info .title {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #040C2D;
}

.srt-info .description {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #667085;
}

.file-drop {
  flex: 1;
}

.video-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.ai-video-button-new {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: euclid_medium, sans-serif;
  font-size: 13px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ai-video-button-new:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.ai-video-button-new:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ai-video-button-new img {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

.agent-select-wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
}

</style>
